export class StorageData {
  storage_connection: string;
  energy_producer_connection: string;
  primary_sources_recorded_separately: boolean | null;
  feed_in_payments_recorded_separately: boolean | null;
  energy_not_supplied_by_grid: boolean | null;
  total_capacity: number | null;
  max_discharge_capacity: number | null;
  number_of_corresponding_figure: string;
}
